import { colors } from "./colors_v2.js";
import { eventHub } from "./eventHub_v2.js";
import { hasDangerousMarkup } from "./escapeHtml_v2.js";

const dasModalState = {
  isOpen: false,
  onClose: null, // set by render({ onClose }), run once by close()
};

const passedValidations = (html) => {
  if (typeof html === "undefined") {
    console.log("ERROR: The html is undefinded");
    return false;
  }
  if (html.length === 0) {
    console.log("ERROR: The html is empty");
    return false;
  }
  // Backstop only (user values must already be escaped). The old check
  // refused any html containing "script", which also blocked names like
  // "Scripter" and let <img onerror=...> through.
  if (hasDangerousMarkup(html)) {
    console.log("ERROR: html contains markup that can run code");
    return false;
  }
  if (html.includes("closeDasModal")) {
    console.log(
      "ERROR: This module adds in a div for closeDasModal, so it can't exist in the html that is passed in.",
    );
    return false;
  }

  return true;
};

const handleClose = (event) => {
  close();
};

const close = () => {
  const dasModal = document.getElementById("dasModal");
  dasModal.classList.add("hideModal");
  dasModal.classList.remove("showModal");

  const dasModalBehinder = document.getElementById("dasModalBehinder");
  dasModalBehinder.style.display = "none";
  delete dasModalBehinder.dataset.action;

  const popBehinder = document.getElementById("popBehinder");
  popBehinder.style.display = "none";
  delete popBehinder.dataset.action;

  dasModalState.isOpen = false;
  dasModal.innerHTML = "";

  // Run the onClose given to render(), once. It runs however the modal
  // closes (the X, clicking outside, or code closing it to show another).
  const onClose = dasModalState.onClose;
  dasModalState.onClose = null;
  if (typeof onClose === "function") {
    setTimeout(onClose, 0);
  }
};

/**
 * @brief Renders the html received as a modal in the center with a close X in the upper right that works.
 * If the html contains buttons or inputs, etc. the module calling this has to add their event listeners.
 * @param {string} html
 * @param {{onClose?: function}} [options]
 * * onClose: called once, after the modal closes for any reason
 * @returns
 */
const render = (html, { onClose } = {}) => {
  if (dasModalState.isOpen) {
    return { status: 429 };
  }
  if (!passedValidations(html)) {
    return { status: 400 };
  }
  dasModalState.isOpen = true;
  dasModalState.onClose = typeof onClose === "function" ? onClose : null;
  const dasModalBehinder = document.getElementById("dasModalBehinder");
  dasModalBehinder.dataset.action = "dasModalBehinderCloseDasModal";
  dasModalBehinder.style.display = "block";
  const dasModal = document.getElementById("dasModal");
  dasModal.classList.remove("hideModal");
  dasModal.classList.add("showModal");

  html = html + `<div class="x" id="closeDasModal"></div>`;
  dasModal.innerHTML = html;
  dasModal.style.backgroundColor = colors.getGameColor("lightAccent");

  colors.setButtonColors();
  return { status: 200 };
};

const renderNoX = (html) => {
  if (!passedValidations(html)) {
    return { status: 400 };
  }
  dasModalState.isOpen = true;
  const dasModalBehinder = document.getElementById("dasModalBehinder");
  dasModalBehinder.style.display = "block";
  const dasModal = document.getElementById("dasModal");
  dasModal.classList.remove("hideModal");
  dasModal.classList.add("showModal");
  dasModal.innerHTML = html;
  dasModal.style.backgroundColor = colors.getGameColor("lightAccent");
  return { status: 200 };
};

eventHub.registerEvent("click", "closeDasModal", handleClose);
eventHub.registerEvent("click", "dasModalBehinderCloseDasModal", close);

export const dasModal = {
  render,
  close,
  renderNoX,
};
